import React from "react";
import { useState, useEffect } from "react";
/* Routing */
import {Link} from "react-router-dom";
/* Contexts */
import useAuth from "../../../hooks/useAuth";
/* External libs */
import {safeJwtDecode} from "../../../helper/jwtHelper";
/* Components */
import FormFilteredDeceasedExport from "../../../forms/deceased/FormFilteredDeceasedExport";
import DocumentListModal from "../../DocumentListModal";
import FormDeceasedNew from "../../../forms/deceased/FormDeceasedNew";
import { getAgencyHeader } from "../../../api/pro/agencyReq";


export default function Menu() {
    const { auth } = useAuth();
    const token = auth?.token;
    const decodedToken = safeJwtDecode(token);
    const id = decodedToken?.agencyId;
    const agencyId = decodedToken?.agency;
    const [ showModal, setShowModal ] = useState(false);
    const [ showDocModal, setShowDocModal ] = useState(false);
    const [ isMobileMenuOpen, setIsMobileMenuOpen ] = useState(false);
    const [ activeMenu, setActiveMenu ] = useState(null);
    const [ agencyInfo, setAgencyInfo ] = useState();
    const username = decodedToken?.userFullName;
    const agencyLogo = decodedToken?.agency_logo;

    useEffect(() => {
        const apiAgencyHeader = async () => {
            const response = await getAgencyHeader(token, agencyId)
            setAgencyInfo(response)
        };
        if (agencyId) {
            apiAgencyHeader();
        }
    }, [agencyId]);

    // Fermer le menu mobile lors du redimensionnement de la fenêtre
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1024) {
                setIsMobileMenuOpen(false);
                setActiveMenu(null);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Empêcher le scroll quand le menu mobile est ouvert
    useEffect(() => {
        if (isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileMenuOpen]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        setActiveMenu(null);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
        setActiveMenu(null);
    };

    const handleFilterDeceased = () => {
        setShowModal(true);
        closeMobileMenu();
    }

    const handleMenuClick = (menuName) => {
        setActiveMenu(activeMenu === menuName ? null : menuName);
    }

    const signout = (e) => {
        e.preventDefault();
        localStorage.removeItem("refresh_token");
        localStorage.setItem("persist", false);
        window.location.href = "/pro/login";
    }

    return (
        <>
            {/* Burger Menu Button */}
            <button
                onClick={toggleMobileMenu}
                className={`burger-menu ${isMobileMenuOpen ? 'open' : ''}`}
                aria-label="Toggle menu"
                aria-expanded={isMobileMenuOpen}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            {/* Overlay pour fermer le menu mobile */}
            {isMobileMenuOpen && (
                <div
                    className="menu-overlay"
                    onClick={closeMobileMenu}
                    aria-hidden="true"
                />
            )}

            <nav className={`pro-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                <div className="top-menu"></div>
                <ul className="home-link no-hover">
                    <Link className="active" to="/" onClick={closeMobileMenu}>
                        <div className="icon-menu home-link">
                            <img src={ agencyLogo } alt="logo pompes funèbres"/>
                            {agencyInfo?.name &&
                                <span className="agency-menu-name">{agencyInfo.name} - {agencyInfo?.city}</span>
                            }
                        </div>
                    </Link>
                </ul>
                {showModal &&
                    <div className="modal filter-modal">
                        <form>
                            <FormFilteredDeceasedExport setShowModal={setShowModal} legend="Informations de décès"/>
                        </form>
                    </div>
                }
                { showDocModal &&
                    <div className="modal docForm">
                        <form>
                            <DocumentListModal setShowDocModal={setShowDocModal}/>
                        </form>
                    </div>
                }
                <div className="right-menu">
                    <ul className={activeMenu === 'account' ? 'active' : ''}>
                        {username
                            ?
                            <>
                                <div className="icon-menu" onClick={() => handleMenuClick('account')}>
                                    <i className="fa fa-user-circle"/>
                                    <span>{username}</span>
                                </div>
                                <ul>
                                    <Link to={`profil`} onClick={closeMobileMenu}>
                                        <li>Profil</li>
                                    </Link>
                                    <Link to={`agence/voir`} onClick={closeMobileMenu}>
                                        <li>Agence</li>
                                    </Link>
                                    <Link to={`funerarium/voir`} onClick={closeMobileMenu}>
                                        <li>Funérarium</li>
                                    </Link>
                                    <Link to={`agence/facturation`} onClick={closeMobileMenu}>
                                        <li>Infos bancaires</li>
                                    </Link>
                                    <Link to={`agence/collaborateurs`} onClick={closeMobileMenu}>
                                        <li>Mes collaborateurs</li>
                                    </Link>
                                    <li>
                                        <button type="button" className="logout-button red-button" onClick={signout}><i className="fa fa-power-off"/><span>Déconnexion</span></button>
                                    </li>
                                </ul>
                            </>
                            : <Link to="pro/login" onClick={closeMobileMenu}>
                                <div className="icon-menu">
                                    <i className="fa fa-user-circle"/>
                                    <span>Me connecter</span>
                                </div>
                            </Link>

                        }
                    </ul>
                    {<ul className={`document-modal ${activeMenu === 'documents' ? 'active' : ''}`} onClick={() => {setShowDocModal(true); handleMenuClick('documents'); closeMobileMenu();}}>
                        <div className="icon-menu"><i className="fa fa-folder-open"/><span>Documents</span></div>
                    </ul>}
                    <ul className={activeMenu === 'tools' ? 'active' : ''}>
                        <div className="icon-menu" onClick={() => handleMenuClick('tools')}><i className="fa fa-tools"/><span>Outils</span></div>
                        <ul>
                            <Link to="defunt/nouveau" element={<FormDeceasedNew/>} onClick={closeMobileMenu}>
                                <li>Création d'un défunt</li>
                            </Link>
                            <Link to={`agence/condoleances`} onClick={closeMobileMenu}>
                                <li>Modération des condoléances</li>
                            </Link>
                            <Link to={`agence/${id}/photos`} onClick={closeMobileMenu}>
                                <li>Gestion des photos</li>
                            </Link>
                            <Link to="/galerie/media" onClick={closeMobileMenu}>
                                <li>Galerie media site</li>
                            </Link>
                            <Link to="/devis-type" onClick={closeMobileMenu}>
                                <li>Gestion des devis type</li>
                            </Link>
                            <Link to={'#'} onClick={handleFilterDeceased}>
                                <li>Export des défunts</li>
                            </Link>
                        </ul>
                    </ul>
                    <Link to="/" className="home-button" onClick={closeMobileMenu}>
                        <i className="fa fa-chevron-left"/>
                        <span>Accueil</span>
                    </Link>
                </div>
            </nav>
        </>
    )
}